import { render, staticRenderFns } from "./MdListCollect.vue?vue&type=template&id=d96f4566&scoped=true&"
import script from "./MdListCollect.vue?vue&type=script&lang=js&"
export * from "./MdListCollect.vue?vue&type=script&lang=js&"
import style0 from "./MdListCollect.vue?vue&type=style&index=0&id=d96f4566&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d96f4566",
  null
  
)

export default component.exports